import React, { useEffect } from 'react';
import { IconType } from 'react-icons';

import * as S from './styles';

export type ToastTone = {
  /** Cor do ícone. */
  accent: string;
  background: string;
  border: string;
  /** Cor do título e da mensagem (ex.: vermelho escuro no erro). */
  text: string;
};

interface ToastProps {
  icon: IconType;
  title: string;
  message: string;
  tone: ToastTone;
  autoClose: number;
  dismiss: () => void;
  /** `alert` para erro/aviso (leitores de tela anunciam na hora); `status` para sucesso. */
  role?: 'alert' | 'status';
}

/**
 * Toast compacto (Figma E-commerce 2026, node 2110:3605): faixa clara com o texto na cor do tipo
 * (ex.: vermelho no erro), centralizada embaixo pelo `ToastContainer` (`bottom-center`).
 * Cores fixas (primitivas) nos dois modos, como uma faixa de papel sobre o conteúdo.
 */
const Toast: React.FC<ToastProps> = ({ icon: IconComponent, title, message, tone, autoClose, dismiss, role }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      dismiss();
    }, autoClose);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <S.Container
      bgColor={tone.background}
      borderColor={tone.border}
      data-app-id="app-toast"
      onClick={dismiss}
      role={role}
      textColor={tone.text}
    >
      <S.IconWrapper>
        <IconComponent aria-hidden color={tone.accent} size={20} />
      </S.IconWrapper>
      <S.Body>
        {title ? <S.Title>{title}</S.Title> : null}
        {message ? <S.Message>{message}</S.Message> : null}
      </S.Body>
    </S.Container>
  );
};

export default Toast;
